import React from "react";
import { getRunDisplayName, type RunHistoryItem } from "../lib/runHistory";

type LocalReportingPeriodSelectorProps = {
  runs: RunHistoryItem[];
  selectedRunId: string | null;
  onChange: (runId: string) => void;
  loading?: boolean;
};

export default function LocalReportingPeriodSelector({
  runs,
  selectedRunId,
  onChange,
  loading = false,
}: LocalReportingPeriodSelectorProps) {
  const resolvedRunId = runs.some((run) => run.run_id === selectedRunId) ? selectedRunId || "" : "";
  return (
    <div data-testid="local-reporting-period" style={styles.wrapper}>
      <label htmlFor="local-reporting-period-select" style={styles.label}>Reporting period</label>
      <select
        id="local-reporting-period-select"
        aria-label="Reporting period"
        data-pdf-static-label="true"
        value={resolvedRunId}
        disabled={loading || runs.length === 0}
        onChange={(event) => onChange(event.target.value)}
        style={styles.select}
      >
        {runs.length === 0 && <option value="">{loading ? "Loading completed runs…" : "No completed runs"}</option>}
        {runs.map((run) => (
          <option key={run.run_id} value={run.run_id}>{getRunDisplayName(run)}</option>
        ))}
      </select>
      <p style={styles.help}>
        This period controls Local visibility, summary, consensus, and history. Opportunity Engine actions remain based on the latest completed run.
      </p>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  wrapper: { display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8, marginTop: 12, maxWidth: 650 },
  label: { color: "#475569", fontSize: 13, fontWeight: 700 },
  select: { flex: "1 1 220px", minWidth: 0, maxWidth: 360, width: "100%", border: "1px solid #cbd5e1", borderRadius: 9, background: "#ffffff", color: "#0f172a", padding: "8px 10px", fontSize: 14 },
  help: { flex: "1 0 100%", margin: 0, color: "#64748b", fontSize: 12, lineHeight: 1.45 },
};
